<template>
  <div class="business-contract">
    <div class="business-contract.header">
      <!-- <el-button
            type="primary"
            class="exportOut"
            icon="el-icon-download"
            @click="exportOut"
      >导出</el-button>-->
      <el-popover placement="bottom" width="300" v-model="visible">
        <el-date-picker
          style="width: 100%"
          v-model="times"
          type="daterange"
          format="yyyy-MM-dd"
          value-format="yyyy-MM-dd"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
        ></el-date-picker>
        <div style="text-align: right; margin-top: 10px">
          <el-button
            size="mini"
            type="text"
            @click="
              () => {
                visible = false;
                times = null;
              }
            "
          >
            取消
          </el-button>
          <el-button type="primary" size="mini" @click="exportOut">确定</el-button>
        </div>
        <el-button
          class="exportOut"
          style="margin-left: 10px"
          slot="reference"
          type="primary"
          icon="el-icon-download"
        >
          导出
        </el-button>
      </el-popover>
      <el-input
        placeholder="请输入项目名称/合同编号"
        v-model="searchValue"
        class="input-with-select"
        @keyup.enter.native="search"
        clearable
        @clear="search"
      >
        <el-button slot="append" icon="el-icon-search" @click="search"></el-button>
      </el-input>
      <label style="margin-right: 10px; line-height: 40px; min-width: 60px">审核状态:</label>
      <el-select v-model="statusVal" placeholder="请选择" @change="search">
        <el-option label="全部" value></el-option>
        <el-option label="待审核" :value="3"></el-option>
        <el-option label="审核中" :value="5"></el-option>
        <el-option label="审核未通过" :value="2"></el-option>
        <el-option label="待签名" :value="1"></el-option>
        <el-option label="签名中" :value="6"></el-option>
        <el-option label="审批通过" :value="7"></el-option>
        <el-option label="已完结" :value="4"></el-option>
      </el-select>
      <label style="margin-right: 10px; line-height: 40px; min-width: 60px">申请来源:</label>
      <el-select
        style="width: 300px"
        v-model="srelease"
        clearable
        placeholder="全部"
        @change="search"
      >
        <el-option label="双平台" :value="1" />
        <el-option label="大市场平台" :value="2" />
        <el-option label="成果交易平台" :value="3" />
      </el-select>
      <label
        style="
          margin-right: 10px;
          margin-left: 100px;
          line-height: 40px;
          min-width: 60px;
        "
      >
        批量下载：
      </label>
      <el-button type="primary" size="mini" @click="exportOuts(1)">技术合同</el-button>
      <el-button type="danger" size="mini" @click="exportOuts(2)">登记证明</el-button>
    </div>
    <Table
      :table="table"
      :url="url"
      @editEvent="editEvent"
      @handleSelectionChange="handleSelectionChange"
      ref="children"
    ></Table>
    <el-dialog
      title="技术合同认定"
      :visible.sync="dialogFormVisible"
      :show-close="false"
      :modal-append-to-body="false"
      :close-on-click-modal="false"
    >
      <el-form :model="form" ref="formDialog" label-width="95px" :rules="formRules">
        <el-row>
          <el-form-item label="合同编号">
            <el-input v-model="form.number" style="width: 100%"></el-input>
          </el-form-item>
        </el-row>
        <el-row :gutter="100">
          <el-col :span="8">
            <el-form-item label="单位名称">
              <el-input v-model="form.unit" style="width: 100%" :disabled="disabled"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="单位地址">
              <el-cascader
                size="large"
                :options="addressOPtions"
                v-model="form.address_prefix"
                style="width: 100%"
                placeholder="请选择省市区"
                clearable
                :disabled="disabled"
              ></el-cascader>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="详细地址">
              <el-input v-model="form.address" style="width: 100%" :disabled="disabled"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="100">
          <el-col :span="12">
            <el-form-item label="联系人">
              <el-input v-model="form.contact" :disabled="disabled"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="联系方式">
              <el-input v-model="form.phone" :disabled="disabled"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="座机号">
              <el-input v-model="form.home_tel" :disabled="disabled"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="短信通知">
              <el-radio-group
                v-model="form.is_phone"
                style="width: 100%; text-align: left"
                :disabled="disabled"
              >
                <el-radio :label="1">是</el-radio>
                <el-radio :label="2">否</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="项目名称">
              <el-input v-model="form.name" :disabled="disabled"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="合同金额">
              <el-input
                style="width: 85%"
                oninput="if(isNaN(value)) { value = value.replace(/[^\d.]/g,'') } if(value.indexOf('.')>0){value=value.slice(0,value.indexOf('.')+0)}"
                v-model="form.contract_amount"
                :disabled="disabled"
              ></el-input>
              <span style="margin-left: 5px">元</span>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item
              label="上传的合同"
              prop="file"
              style="text-align: left"
              class="file-class"
            >
              <a
                style="margin-right: 10px"
                :href="imgUrl + getDownUrl(item.url)"
                target="_blank"
                v-for="(item, index) in form.file"
                :key="index"
              >
                {{ item.name }}
              </a>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row style="margin-top: 20px">
          <el-col :span="24">
            <el-form-item label="备注">
              <el-input
                type="textarea"
                :autosize="{ minRows: 6, maxRows: 6 }"
                v-model="form.remark"
                :disabled="disabled"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item style="text-align: left" label="合同类型" prop="category">
          <el-radio-group v-model="form.category" :disabled="disabled">
            <el-radio :label="item.value" v-for="item in typeoption" :key="item.value">
              {{ item.label }}
            </el-radio>
          </el-radio-group>
        </el-form-item>
        <el-row>
          <el-col :span="12">
            <el-form-item prop="tech_field" label="技术领域">
              <el-select
                v-model="form.tech_field"
                clearable
                placeholder="请选择技术领域"
                style="width: 100%"
                :disabled="disabled"
              >
                <el-option
                  v-for="item in fieldOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="技术需求方" prop="provide" label-width="100px">
              <el-input
                v-model="form.provide"
                clearable
                placeholder="请输入技术需求方"
                :disabled="disabled"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item label="补正意见" prop="suggest">
          <el-input
            type="textarea"
            :autosize="{ minRows: 6, maxRows: 6 }"
            placeholder="请输入内容..."
            v-model="form.suggest"
            :disabled="disabled"
          ></el-input>
        </el-form-item>
        <el-row>
          <el-col :span="6">
            <el-row>
              <el-form-item label="一级审核人" prop="checker_id" style="width: 100%">
                <el-select
                  style="width: 100%"
                  v-model="form.checker_id"
                  placeholder="请选择"
                  :disabled="showUser[0]"
                >
                  <el-option
                    v-for="item in userOptions"
                    :key="item.id"
                    :label="item.username"
                    :value="item.id"
                    :disabled="item.disabled"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-row>
            <el-row>
              <el-form-item label="审核" prop="status" style="width: 100%">
                <el-select
                  style="width: 100%"
                  v-model="form.status"
                  placeholder="请选择"
                  :disabled="showCheck[0]"
                >
                  <el-option
                    v-for="item in options"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                    :disabled="item.disabled"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-row>
          </el-col>
          <el-col :span="6" v-if="form.status == 1">
            <el-row>
              <el-form-item label="二级审核人" prop="checker_id1" style="width: 100%">
                <el-select
                  style="width: 100%"
                  v-model="form.checker_id1"
                  placeholder="请选择"
                  :disabled="showUser[1]"
                >
                  <el-option
                    v-for="item in userOptions1"
                    :key="item.id"
                    :label="item.username"
                    :value="item.id"
                    :disabled="item.disabled"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-row>
            <el-row>
              <el-form-item label="审核" prop="status1" style="width: 100%">
                <el-select
                  style="width: 100%"
                  v-model="form.status1"
                  placeholder="请选择"
                  :disabled="showCheck[1]"
                >
                  <el-option
                    v-for="item in options"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                    :disabled="item.disabled"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-row>
          </el-col>
          <el-col :span="6" v-if="form.status1 == 1">
            <el-row>
              <el-form-item label="初级审核人" prop="checker_id2" style="width: 100%">
                <el-select
                  style="width: 100%"
                  v-model="form.checker_id2"
                  placeholder="请选择"
                  :disabled="showUser[2]"
                >
                  <el-option
                    v-for="item in userOptions2"
                    :key="item.id"
                    :label="item.username"
                    :value="item.id"
                    :disabled="item.disabled"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-row>
            <el-row>
              <el-form-item label="审核" prop="status2" style="width: 100%">
                <el-select
                  style="width: 100%"
                  v-model="form.status2"
                  placeholder="请选择"
                  :disabled="showCheck[2]"
                >
                  <el-option
                    v-for="item in options"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                    :disabled="item.disabled"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-row>
          </el-col>
          <el-col :span="6" v-if="form.status2 == 1">
            <el-row>
              <el-form-item label="终级审核人" prop="checker_id3" style="width: 100%">
                <el-select
                  style="width: 100%"
                  v-model="form.checker_id3"
                  placeholder="请选择"
                  :disabled="showUser[3]"
                >
                  <el-option
                    v-for="item in userOptions3"
                    :key="item.id"
                    :label="item.username"
                    :value="item.id"
                    :disabled="item.disabled"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-row>
            <el-row>
              <el-form-item label="审核" prop="status3" style="width: 100%">
                <el-select
                  style="width: 100%"
                  v-model="form.status3"
                  placeholder="请选择"
                  :disabled="showCheck[3]"
                >
                  <el-option
                    v-for="item in options"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                    :disabled="item.disabled"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-row>
          </el-col>
        </el-row>
        <el-row :gutter="30" v-if="form.status3 == 1">
          <el-col :span="6">
            <el-form-item label="大市场签字" prop="checker_id_market" style="width: 100%">
              <el-select
                style="width: 100%"
                v-model="form.checker_id_market"
                placeholder="请选择"
                :disabled="showCheck[6] && ((!showCheck[3] && form.status3 === 1) ? false : true)"
              >

                <el-option
                  v-for="item in userOptions4"
                  :key="item.id"
                  :label="item.username"
                  :value="item.id"
                  :disabled="item.disabled"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="签名" v-if="signature" prop="sign_image_market">
              <div style="background: #ccc;" v-if="showCheck[4] && !hallsignature">待审核</div>
              <template v-else-if="!form.sign_image_market">
                <vue-qr id="qrcode" :text="signUrl" height="120" width="120" />
                <div style="position: relative;top: -27px;left: 3px;color: #000;">手机扫码签名</div>
              </template>
              <span v-else>
                <img class="qianming" :src="this.imgUrl + form.sign_image_market" alt="" srcset="" />
                <el-button type="text" @click="reSign" v-if="!hallsignature">重新签名</el-button>
              </span>
            </el-form-item>
          </el-col>
          <el-col :span="6" v-if="signature && form.sign_image_market">
            <el-form-item label="科技厅签字" prop="checker_id_achievement" style="width: 100%">
              <el-select
                style="width: 100%"
                v-model="form.checker_id_achievement"
                placeholder="请选择"
                :disabled="hallsignature ? true : showCheck[4]"
              >
                <el-option
                  v-for="item in userOptions5"
                  :key="item.id"
                  :label="item.username"
                  :value="item.id"
                  :disabled="item.disabled"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="签名" v-if="hallsignature" prop="sign_image_achievement">
              <div style="background: #ccc;" v-if="showCheck[5] && !imageachievement">待审核</div>
              <template v-else-if="!form.sign_image_achievement">
                <vue-qr id="qrcode" :text="signUrl" height="120" width="120" />
                <div style="position: relative;top: -27px;left: 3px;color: #000;">手机扫码签名</div>
              </template>
              <span v-else>
                <img class="qianming" :src="this.imgUrl + form.sign_image_achievement" alt="" srcset="" />
                <el-button type="text" @click="reSign" v-if="!imageachievement">重新签名</el-button>
              </span>
            </el-form-item>
          </el-col>
        </el-row>
        <!-- <el-row :gutter="30" v-if="form.status3 == 1 && isUpload && imageachievement">
          <el-col :span="6">
            <span>上传</span>
          </el-col>
          <el-col :span="8">
            <el-form-item label="登记证明" prop="fileList">
              <el-upload
                class="upload-demo"
                :action="this.uploadURL"
                name="file"
                :file-list="form.fileList"
                :on-success="
                  (response, file, fileList) => onSuccess(response, file, fileList, 'fileList')
                "
                :show-file-list="true"
                :on-preview="onPreview"
                :on-remove="(file, fileList) => handleRemove(file, fileList, 'fileList')"
              >
                点击上传
              </el-upload>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="技术合同" prop="fileList_two">
              <el-upload
                class="upload-demo"
                :action="this.uploadURL"
                name="file"
                :file-list="form.fileList_two"
                :on-success="
                  (response, file, fileList) => onSuccess(response, file, fileList, 'fileList_two')
                "
                :show-file-list="true"
                :on-preview="onPreview"
                :on-remove="(file, fileList) => handleRemove(file, fileList, 'fileList_two')"
              >
                点击上传
              </el-upload>
            </el-form-item>
          </el-col>
        </el-row> -->
        <el-form-item style="text-align: right">
          <el-button @click="close('formDialog')">取消</el-button>
          <el-button type="primary" v-if="!hallsignature || !imageachievement" @click="submit('formDialog')">确认</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import Table from './table.vue';
import { regionData } from 'element-china-area-data';
import { FunDownload, GetUrlName } from '@/utils/tool';
import { getUserInfo, getToken } from '@/utils/auth';
import { eventSourceMethods } from '@/utils/eventSourceMethods';
import VueQr from 'vue-qr';
export default {
  components: {
    Table,
    VueQr,
  },
  mixins: [eventSourceMethods],
  data() {
    return {
      isUpload: false,
      disabled: true,
      signature: false,
      hallsignature: false,
      imageachievement:false,
      showCheck: [true, true, true, true, true, true, true],
      showUser: [true, true, true, true, true, true],
      visible: false,
      times: '',
      table: {
        columns: [
          {
            prop: 'name',
            label: '项目名称',
          },
          {
            prop: 'contractAmount',
            label: '技术交易额',
          },
          {
            prop: 'number',
            label: '合同编号',
          },
          {
            prop: 'address',
            label: '地区',
          },
          {
            prop: 'dateTime',
            label: '申请时间',
          },
          {
            prop: 'isAchievement',
            label: '申请来源',
            type: 'is_achievement',
          },
          // {
          //   prop: "date_time",
          //   label: "审核时间"
          // },
          // {
          //   prop: "date_time",
          //   label: "办理完结时间"
          // },
          {
            prop: 'status',
            label: '审核状态',
            type: 'status_pop',
          },
          {
            prop: 'down',
            label: '附件',
          },
        ],
        hasBtn: true,
        hasSelect: true,
        btns: [
          {
            name: '编辑',
            event: 'editEvent',
            type: 'success',
          },
        ],
      },
      addressOPtions: regionData,
      url: 'Technology_Skill?type=3',
      searchValue: '',
      statusVal: '',
      srelease: '',
      dialogFormVisible: false,
      // optionsReset: [],
      userOptions: [],
      userOptions1: [],
      userOptions2: [],
      userOptions3: [],
      userOptions4: [],
      userOptions5: [],
      options: [
        {
          id: 3,
          name: '未审核',
          disabled: true,
        },
        {
          id: 1,
          name: '审核通过',
          disabled: false,
        },
        {
          id: 2,
          name: '审核不通过',
          disabled: false,
        },
        // {
        //   id: 4,
        //   name: "已完结",
        //   disabled: true,
        // },
      ],
      typeoption: [
        {
          label: '技术开发合同',
          value: 1,
        },
        {
          label: '技术转让合同',
          value: 2,
        },
        {
          label: '技术服务合同',
          value: 3,
        },
        {
          label: '技术咨询合同',
          value: 4,
        },
        {
          label: '技术许可合同',
          value: 6,
        },
        {
          label: '不属于技术合同',
          value: 5,
        },
      ],
      fieldOptions: [
        { label: '电子信息', value: 1 },
        { label: '航空航天', value: 2 },
        { label: '装备制造', value: 3 },
        { label: '生物、医药和医疗器械', value: 4 },
        { label: '新材料及其应用', value: 5 },
        { label: '新能源与高效节能', value: 6 },
        { label: '环境保护与资源综合利用', value: 7 },
        { label: '核应用', value: 8 },
        { label: '农业', value: 9 },
        { label: '现代交通', value: 10 },
        { label: '城市建设与社会发展', value: 11 },
      ],
      form: {
        number:'',
        unit: '',
        address_prefix: '',
        home_tel: '',
        address: '',
        contact: '',
        phone: '',
        is_phone: 1,
        file: [],
        remark: '',
        suggest: '',
        id: '',
        name: '',
        contract_amount: '',
        category: '',
        fileList: '',
        fileList_two: '',
        provide: '',
        tech_field: '',
        status: '',
        status1: '',
        status2: '',
        status3: '',
        // status4: '',
        // status5: '',
        checker_id: '',
        checker_id1: '',
        checker_id2: '',
        checker_id3: '',
        checker_id_market: '',
        checker_id_achievement: '',
      },
      formRules: {
        tech_field: [
          {
            required: true,
            message: '请选择技术领域',
            trigger: 'blur',
          },
        ],
        provide: [
          {
            required: true,
            message: '请输入技术需求方',
            trigger: 'blur',
          },
        ],
        fileList: [
          {
            required: true,
            message: '请上传登记证明',
            trigger: 'change',
          },
        ],
        // fileList_two: [
        //   {
        //     required: true,
        //     message: "请上传技术合同",
        //     trigger: "change",
        //   },
        // ],
        checker_id: [
          {
            required: true,
            message: '请选择一级审核员',
            trigger: 'change',
          },
        ],
        checker_id1: [
          {
            required: true,
            message: '请选择二级审核员',
            trigger: 'change',
          },
        ],
        checker_id2: [
          {
            required: true,
            message: '请选择初级审核员',
            trigger: 'change',
          },
        ],
        checker_id3: [
          {
            required: true,
            message: '请选择终级审核员',
            trigger: 'change',
          },
        ],
        checker_id_market: [
          {
            required: true,
            message: '请选择大市场签字',
            trigger: 'change',
          },
        ],
        sign_image_market:[
          {
            required: true,
            message: '请大市场签字',
            trigger: 'change',
          }
        ],
        checker_id_achievement: [
          {
            required: true,
            message: '请选择科技厅签字',
            trigger: 'change',
          },
        ],
        sign_image_achievement:[
          {
            required: true,
            message: '请科技厅签字',
            trigger: 'change',
          }
        ]
      },
      selectRow: [],
    };
  },
  created() {
    this.getRoles();
  },
  methods: {
    getStatus(status) {
      const item = this.options.find(val => val.id == status);
      if (item) {
        return item.name;
      }
      return '';
    },
    checkMethod() {
      this.isUpload = false;
      this.disabled = true;
      this.showCheck = [true, true, true, true, true, true,true];
      this.showUser = [true, false, false, false, false, false];
      let perm_level = JSON.parse(getUserInfo()).perm_level; //账号的审批权限
      let perm_id = getToken(); //账号的id
      if (perm_id == this.form.checker_id || perm_id == this.form.checker_id2) {
        this.isUpload = true;
      }
      switch (this.form.status) {
        case 3:
          if (perm_level == 1) {
            this.form.checker_id = Number(perm_id);
            this.showCheck[0] = false;
            this.disabled = false;
          }
          break;
        case 2:
          if (this.form.checker_id == Number(perm_id)) {
            this.showCheck[0] = false;
            this.disabled = false;
          }
          break;
      }
      if (this.form.status == 1) {
        if (this.form.status1 == 3 && this.form.checker_id == Number(perm_id)) {
          this.showUser[1] = false;
          this.disabled = false;
        } else {
          this.showUser[1] = true;
        }
        switch (this.form.status1) {
          case 3:
            if (this.form.checker_id1 == Number(perm_id)) {
              this.showCheck[1] = false;
              this.disabled = false;
            }
            break;
          case 2:
            if (this.form.checker_id1 == Number(perm_id)) {
              this.showCheck[1] = false;
              this.disabled = false;
            }
            break;
        }
      }
      if (this.form.status1 == 1) {
        if (this.form.status2 == 3 && this.form.checker_id1 == Number(perm_id)) {
          this.showUser[2] = false;
          this.disabled = false;
        } else {
          this.showUser[2] = true;
        }
        switch (this.form.status2) {
          case 3:
            if (this.form.checker_id2 == Number(perm_id)) {
              this.showCheck[2] = false;
              // this.disabled = false;
            }
            break;
          case 2:
            if (this.form.checker_id2 == Number(perm_id)) {
              this.showCheck[2] = false;
              // this.disabled = false;
            }
            break;
        }
      }
      if (this.form.status2 == 1) {
        if (this.form.status3 == 3 && this.form.checker_id2 == Number(perm_id)) {
          this.showUser[3] = false;
          // this.disabled = false;
        } else {
          this.showUser[3] = true;
        }
        switch (this.form.status3) {
          case 3:
            if (this.form.checker_id3 == Number(perm_id)) {
              this.showCheck[3] = false;
              // this.disabled = false;
            }
            break;
          case 2:
            if (this.form.checker_id3 == Number(perm_id)) {
              this.showCheck[3] = false;
              // this.disabled = false;
            }
            break;
          case 1:
            if (this.form.checker_id3 == Number(perm_id) && !this.form.sign_image_market) {
              this.showCheck[6] = false;
              // this.disabled = false;
            }
            break;
        }
      }
      if (this.form.status3 == 1) {
            if (this.form.checker_id_market == Number(perm_id)) {
              this.showCheck[4] = false;
              // this.disabled = false;
            }
      }
      if (this.form.status3 == 1) {
            if (this.form.checker_id_achievement == Number(perm_id)) {
              this.showCheck[5] = false;
              // this.disabled = false;
            }
      }
      //
      // if (this.form.status4 == 1) {
      //   if (this.form.status5 == 3 && this.form.checker_id_market == Number(perm_id)) {
      //     this.showUser[5] = false;
      //     // this.disabled = false;
      //   } else {
      //     this.showUser[5] = true;
      //   }
      //   switch (this.form.status5) {
      //     case 3:
      //       if (this.form.checker_id_achievement == Number(perm_id)) {
      //         this.showCheck[5] = false;
      //         // this.disabled = false;
      //       }
      //       break;
      //     case 2:
      //       if (this.form.checker_id_achievement == Number(perm_id)) {
      //         this.showCheck[5] = false;
      //         // this.disabled = false;
      //       }
      //       break;
      //   }
      // }
    },
    getRoles() {
      this.http.get('/User?type=2&perm_level=1').then(res => {
        if (res.code == 0) {
          this.userOptions = res.data.data;
        }
      });
      this.http.get('/User?type=2&perm_level=2').then(res => {
        if (res.code == 0) {
          this.userOptions1 = res.data.data;
        }
      });
      this.http.get('/User?type=2&perm_level=3').then(res => {
        if (res.code == 0) {
          this.userOptions2 = res.data.data;
        }
      });
      this.http.get('/User?type=2&perm_level=4').then(res => {
        if (res.code == 0) {
          this.userOptions3 = res.data.data;
        }
      });
      this.http.get('/User?type=2&perm_level=5').then(res => {
        if (res.code == 0) {
          this.userOptions4 = res.data.data;
        }
      });
      this.http.get('/User?type=2&perm_level=6').then(res => {
        if (res.code == 0) {
          this.userOptions5 = res.data.data;
        }
      });
    },
    //批量下载
    exportOuts(type) {
      if (!this.selectRow.length) {
        this.$message.warning('请选择所需下载的项目');
      } else {
        let arr = [];
        this.selectRow.forEach(item => {
          arr.push(item.id);
        });
        let url =
          type == 1 ? 'Technology_Skill/download/contract/' : 'Technology_Skill/download/cert/';
        var a = document.createElement('a');
        a.href = this.urlConfig.url + url + arr.join(',');
        a.download = '';
        a.setAttribute('target', '_blank');
        a.click();
      }
    },
    //选择
    handleSelectionChange(val) {
      this.selectRow = val;
    },
    getDownUrl(url) {
      if (url.search(this.imgUrl) !== -1) {
        return url.substr(this.imgUrl.length - url.length);
      } else {
        return url;
      }
    },
    onPreview(file) {
      let tmp = file?.url || file.response.data.store_result;
      let url = this.getDownUrl(tmp);
      FunDownload(this.imgUrl + url, file.name);
    },
    onSuccess(file, fileList, list, type) {
      this.$refs.formDialog.clearValidate(type);
      this.form[type] = list.map(el => {
        return {
          name: el.name,
          url: el?.url || el.response.data.store_result,
        };
      });
    },
    handleRemove(file, fileList, type) {
      this.form[type] = fileList;
    },
    handleChange(file) {},
    //导出
    exportOut() {
      let url = '';
      if (this.times) {
        /*url =
          window.urlConfig.url +
          'Technology_Skill_Export?type=3&time_type=1&start_datetime=' +
          this.times[0] +
          '&end_datetime=' +
          this.times[1];*/
        url = `${urlConfig.devUrl}apij2/admin-api/signature/technology-skill/export-excel?type=3&time_type=1&date=`+this.times
      } else {
        // url = window.urlConfig.url + 'Technology_Skill_Export?type=3';
        url = `${urlConfig.devUrl}apij2/admin-api/signature/technology-skill/export-excel?type=3`
      }
      var a = document.createElement('a');
      a.href = url;
      a.download = '';
      a.click();
      this.visible = false;
      this.times = null;
    },
    search() {
      var str = this.srelease
        ? this.srelease === 1
          ? '&isMarket=1&isAchievement=1'
          : this.srelease === 2
          ? '&isMarket=1&isAchievement=2'
          : '&isMarket=2&isAchievement=1'
        : '';
      this.url = `/Technology_Skill?type=3&search=${this.searchValue}&status=${this.statusVal}${str}`;
    },
    editEvent(row) {
      this.dialogFormVisible = true;
      this.form.unit = row.unit;
      this.form.number = row.number;
      this.form.address_prefix = JSON.parse(row.addressPrefix);
      this.form.address = row.address;
      this.form.contact = row.contact;
      this.form.phone = row.phone;
      this.form.is_phone = row.isPhone;
      this.form.file = this.formatFile(row.file);
      this.form.remark = row.remark;
      this.form.suggest = row.suggest;
      this.form.id = row.id;
      this.form.name = row.name;
      this.form.tech_field = row.techField ? row.techField : '';
      this.form.home_tel = row.homeTel;
      this.form.contract_amount = Math.ceil(row.contractAmount * 10000);
      this.form.category = row.category;
      this.form.user_id = row.userId;
      this.form.provide = row.provide;
      // this.options = JSON.parse(this.optionsReset).map((el) => el);
      // console.log("结果展示", row.technical_certificate_src?.split(","));
      let arr = row.technicalCertificateSrc?.split(',') || [];
      this.form.status = Number(row.status);
      this.form.status1 = Number(row.status1);
      this.form.status2 = Number(row.status2);
      this.form.status3 = Number(row.status3);
      // this.form.status4 = Number(row.status4);
      // this.form.status5 = Number(row.status4);
      this.form.checker_id = row.checkerId ? Number(row.checkerId) : '';
      this.form.checker_id1 = row.checkerId1 ? Number(row.checkerId1) : '';
      this.form.checker_id2 = row.checkerId2 ? Number(row.checkerId2) : '';
      this.form.checker_id3 = row.checkerId3 ? Number(row.checkerId3) : '';
      this.form.checker_id_market = row.checkerIdMarket ? Number(row.checkerIdMarket) : '';
      this.form.checker_id_achievement = row.checkerIdAchievement
        ? Number(row.checkerIdAchievement)
        : '';
        this.form.sign_image_market = row.signImageMarket
       this.form.sign_image_achievement = row.signImageAchievement
      this.form.fileList =
        arr.length && arr[0]
          ? arr.map(el => {
              return {
                uid: Math.random() * 5 + Math.random() * 10 + Math.random() * 25,
                url: el,
                name: GetUrlName(el),
              };
            })
          : [];

      let two = row.technicalContractSrc?.split(',') || [];
      this.form.fileList_two =
        two.length && two[0]
          ? two.map(el => {
              return {
                url: el,
                uid: Math.random() * 5 + Math.random() * 10 + Math.random() * 25,
                name: GetUrlName(el),
              };
            })
          : [];

      // console.log(two.length, two, this.form.fileList_two);

      if (row.status == 4) {
        let arr = this.options;
        this.options = [];
        this.options = arr.map(el => {
          el.disabled = true;
          return el;
        });
      }
      // 判断应该大市场签字还是科技厅签字 并且生成相应的url
      this.signature = row.checkerIdMarket ? true : false;
      this.hallsignature = row.checkerIdAchievement ? true : false;
      this.imageachievement = row.signImageAchievement ? true : false;
      this.reSigna();
      if (this.signature) {
        if (this.hallsignature) {
          if(!this.imageachievement){
            this.getSignUrl(new Date().getTime());
          }
        }else{
          this.getSignUrl(new Date().getTime());
        }
      }
      this.form = Object.assign({}, row, this.form);
      this.checkMethod();
    },
    reSign(){
      if (this.signature) {
        if (this.hallsignature) {
          if(!this.imageachievement){
            this.form.sign_image_achievement = ''
          this.reSigna();
          this.getSignUrl(new Date().getTime());
          }
        }else{
          this.form.checker_id_achievement = ''
          this.form.sign_image_market = ''
          this.reSigna();
          this.getSignUrl(new Date().getTime());
        }
      }
      // else {
      //
      // }

    },
    close(formName) {
      this.closeSseConnect();
      this.$refs[formName].resetFields();
      this.dialogFormVisible = false;
    },
    // 预留文件类型过滤
    getFileName(url) {
      let name = '';
      if (url !== null && url !== '') {
        name = url.substring(url.lastIndexOf('/') + 1);
        // name = url.substring(url.lastIndexOf('!') + 1);
      } else {
        name = '无';
      }
      return name;
    },
    formatFile(files) {
      let arrs = [];
      files &&
        files.split(',').forEach((item, index) => {
          arrs.push({
            name: '材料-' + (index + 1),
            // name: this.getFileName(item),
            url: item,
          });
        });
      return arrs;
    },
    // 发送短信验证码
    sendMessage(content, phone) {
      this.http
        .post('code/common_send', {
          content: content,
          phone: phone,
        })
        .then(res => {});
    },
    submit(formName) {
      this.$refs.formDialog.validate((valid, test) => {
        let tip = '';
        let obj = JSON.parse(JSON.stringify(this.form));
        console.log(obj);
        if (valid) {
        if(this.signature && !this.hallsignature){
          this.http.post(`${urlConfig.devUrl}apij2/admin-api/signature/technology-skill/signature`,
              {
                id:obj.id,//id
                checkerId:obj.checker_id_achievement,//下一级审核人id
                signImage:this.imgUrl + obj.sign_image_market,//审核人签名图片
                checkerType:1,//审核签字类型：1大市场签字 2科技厅签字,示例值(1)
              }
            ).then(res => {
              const loading = this.$loading({
              lock: true,
              text: '登记中...',
              spinner: 'el-icon-loading',
              background: 'rgba(0, 0, 0, 0.7)'
            });
            setTimeout(() => {
              loading.close();
                this.closeSseConnect();
                this.dialogFormVisible = false;
                this.$refs.children.getData(this.url);
            }, 2000);
          });
        }else if(this.signature && this.hallsignature){
          this.http.post(`${urlConfig.devUrl}apij2/admin-api/signature/technology-skill/signature`,
              {
                id:obj.id,//id
                checkerId:null,//下一级审核人id
                signImage:this.imgUrl + obj.sign_image_achievement,//审核人签名图片
                checkerType:2,//审核签字类型：1大市场签字 2科技厅签字,示例值(1)
              }
            ).then(res => {
              const loading = this.$loading({
                lock: true,
                text: '登记中...',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
              });
              setTimeout(() => {
                loading.close();
                  this.closeSseConnect();
                  this.dialogFormVisible = false;
                  this.$refs.children.getData(this.url);
              }, 2000);
          });
        }else{
          obj.contractAmount = this.form.contract_amount / 10000;
          obj.status = this.form.status;
          obj.status1 = this.form.status1;
          obj.status2 = this.form.status2;
          obj.status3 = this.form.status3;
          // obj.status4 = this.form.status4;
          // obj.status5 = this.form.status5;
          obj.checkerId = this.form.checker_id ? this.form.checker_id : 0;
          obj.checkerId1 = this.form.checker_id1 ? this.form.checker_id1 : 0;
          obj.checkerId2 = this.form.checker_id2 ? this.form.checker_id2 : 0;
          obj.checkerId3 = this.form.checker_id3 ? this.form.checker_id3 : 0;
          obj.checkerIdMarket = this.form.checker_id_market ? this.form.checker_id_market : 0;
          obj.checkerIdAchievement = this.form.checker_id_achievement
            ? this.form.checker_id_achievement
            : 0;
          obj.category = this.form.category;
          obj.type = 3;
          obj.userId = this.form.user_id;
          obj.techField = this.form.tech_field ? this.form.tech_field : '';
          obj.provide = this.form.provide;
          obj.addressPrefix = JSON.stringify(this.form.address_prefix);
          // if (obj.status == 1) {
          //   console.log("数据提交", this.fileList);
          let strFile = this.form.file.map(el => {
            return el.url;
          });

          let str = this.form.fileList.map(el => {
            return el.url;
          });
          let str_two = this.form.fileList_two.map(el => {
            return el.url;
          });
          obj.file = strFile.join();
          obj.technicalCertificateSrc = str.join();
          obj.technicalContractSrc = str_two.join();
          //   tip =
          //     "恭喜您预约的办理技术合同认定登记审核通过，请登录平台查看详情。";
          // }
          // if (obj.status == 2) {
          //   tip =
          //     "很遗憾的通知到您，您预约的办理技术合同认定登记审核未通过，请登录平台查看详情。";
          // }

          obj.suggest = this.form.suggest;

          delete obj.fileList;
          delete obj.fileList_two;
          obj.id = this.form.id;
          // this.http.put('Technology_Skill/' + this.form.id, obj).then(res => {
          this.http.post(`${urlConfig.devUrl}apij2/admin-api/signature/technology-skill/update`, obj).then(res => {
            if (res.code == 0) {
              this.$message.success('审核成功');
              this.closeSseConnect();
              this.dialogFormVisible = false;
              this.$refs.children.getData(this.url);
            }
          });
        }
        } else {
          console.log('校验结果', valid, test);
        }
      });
    },
  },
};
</script>

<style lang="scss">
@include component(business-contract) {
  .upload-demo {
    border: 1px dashed #cccccc;
  }

  @include part(header) {
    width: 100%;
    text-align: left;
    display: flex;
    justify-content: flex-start;
    margin-bottom: 20px;

    .el-input {
      width: 300px;
      margin: 0 15px;
    }
  }

  .file-class {
    .el-form-item__content {
      display: flex;
      flex-direction: column;
    }
  }
  .qianming{
    width: 150px;
    max-height: 150px;
  }
}
</style>
